module.exports = __webpack_public_path__ + "static/media/plastic-surgery-banner.741b661e.png";